import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";
import {
    IMyCompanyBank
} from "../../../../../../../utils/interfaces/my_company/my_company_registry/my_company_bank/IMyCompanyBank";


const useApiUpdateBank = (): UseMutationResult<IMyCompanyBank, CustomAxiosError, {
    id: number;
    data: any
}, unknown> => {
    const queryClient = useQueryClient();
    const {selectedCompany} = useAuth()

    const {put} = useApiCalls()

    async function doUpdate(company_token: string | undefined,
                            pk: number | undefined,
                            data: any): Promise<IMyCompanyBank> {
        try {
            const response = await put(`/api/company/${company_token}/my_company/my_company_registry/bank/${pk}`, data);
            return response.data as IMyCompanyBank;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<IMyCompanyBank, CustomAxiosError, {
        id: number;
        data: any
    }, unknown>({
        mutationFn: async ({id, data}) => {
            return await doUpdate(selectedCompany?.company_token, id, data);
        },
        onSuccess: async (data) => {
            await queryClient.invalidateQueries({queryKey: ['useApiGetMyCompanyBank', data.id]});
            await queryClient.invalidateQueries({queryKey: ["useApiGetMyCompanyBanks"]});
        },
    });
};


export default useApiUpdateBank;